import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, Tooltip } from "antd";
import { OrderedListOutlined, RollbackOutlined } from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockMovementHistoryFilter from "../Filters/StockMovementHistoryFilter";
import CurrencyFormat from "react-currency-format";

const StockMovementByStockList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "STOK HAREKETLERİ",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(
    () => getTableData(),
    [props.match.params.stockId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/StockMovement/GetListByStockId/${props.match.params.stockId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response,
        loading: false,
        total: response.length,
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "left",
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "left",
    },
    {
      title: "Hareket Tarihi",
      dataIndex: "addDateString",
      key: "addDateString",
      align: "left",
    },
    {
      title: "Hareket Tipi",
      dataIndex: "stockMovementTypeName",
      key: "stockMovementTypeName",
      align: "left",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";
        else
          return (
            <Tooltip title={text}>
              <span>
                {text.substring(0, 20).length < 20
                  ? text.substring(0, 20) + ""
                  : text.substring(0, 20) + "..."}
              </span>
            </Tooltip>
          );
      },
    },
    {
      title: "Proje",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
    },
    {
      title: "Giren Stok",
      dataIndex: "addStockCount",
      key: "addStockCount",
      align: "left",
      render: (text) => (
        <div style={{ color: "green" }}>
          {renderDecimal(text) == "0,00" ? "" : renderDecimal(text)}
        </div>
      ),
    },
    {
      title: "Çıkan Stok",
      dataIndex: "stockOutCount",
      key: "stockOutCount",
      align: "left",
      render: (text) => (
        <div style={{ color: "red" }}>
          {renderDecimal(text) == "0,00" ? "" : renderDecimal(text)}
        </div>
      ),
    },
    {
      title: "Çıkan Depo",
      dataIndex: "fromTransactionProjectTypeName",
      key: "fromTransactionProjectTypeName",
      align: "center",
    },
    {
      title: "Transfer Depo",
      dataIndex: "toTransactionProjectTypeName",
      key: "toTransactionProjectTypeName",
      align: "center",
    },
    {
      title: "Güncel Stok",
      dataIndex: "stockBalanceTotal",
      key: "stockBalanceTotal",
      align: "center",
      render: renderDecimal,
    },
    {
      title: "Stok Birimi",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "Birim Fiyat",
      dataIndex: "amountString",
      key: "amountString",
      align: "left",
    },
    {
      title: "Toplam Fiyat",
      dataIndex: "totalAmountString",
      key: "totalAmountString",
      align: "left",
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>
      <StockMovementHistoryFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={false}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockMovementByStockList;
